import React, { useContext } from "react";
import { initialReducerData, NewAppointmentState } from "./index.reducer";
import type { SetCustomerInfoPayload, SetStaffDatePayload } from './index.actions';
import type { Service } from 'types/models';

export interface AptContextValue {
  state: NewAppointmentState;
  actions: {
    setCustomerInfo: (payload?: SetCustomerInfoPayload) => void;
    setServices: (payload: Service[]) => void;
    setStaffDate: (payload: SetStaffDatePayload) => void;
    setTimeSlot: (payload: string | null) => void;
    setNote: (payload: string) => void;
    setGroupValue: (payload: number) => void;
    reset: () => void;
  };
}

const AptContext = React.createContext<AptContextValue>({
  state: initialReducerData,
  actions: {
    setCustomerInfo: () => undefined,
    setServices: () => undefined,
    setStaffDate: () => undefined,
    setTimeSlot: () => undefined,
    setNote: () => undefined,
    setGroupValue: () => undefined,
    reset: () => undefined,
  }
});

export const useAptContext = () => useContext(AptContext);

export default AptContext;
